(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('specializzazione', {
            parent: 'entity',
            url: '/specializzazione',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.specializzazione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/specializzazione/specializzaziones.html',
                    controller: 'SpecializzazioneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specializzazione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('specializzazione-detail', {
            parent: 'entity',
            url: '/specializzazione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.specializzazione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/specializzazione/specializzazione-detail.html',
                    controller: 'SpecializzazioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('specializzazione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Specializzazione', function($stateParams, Specializzazione) {
                    return Specializzazione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'specializzazione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('specializzazione-detail.edit', {
            parent: 'specializzazione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specializzazione/specializzazione-dialog.html',
                    controller: 'SpecializzazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Specializzazione', function(Specializzazione) {
                            return Specializzazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('specializzazione.new', {
            parent: 'specializzazione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specializzazione/specializzazione-dialog.html',
                    controller: 'SpecializzazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('specializzazione', null, { reload: 'specializzazione' });
                }, function() {
                    $state.go('specializzazione');
                });
            }]
        })
        .state('specializzazione.edit', {
            parent: 'specializzazione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specializzazione/specializzazione-dialog.html',
                    controller: 'SpecializzazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Specializzazione', function(Specializzazione) {
                            return Specializzazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('specializzazione', null, { reload: 'specializzazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('specializzazione.delete', {
            parent: 'specializzazione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/specializzazione/specializzazione-delete-dialog.html',
                    controller: 'SpecializzazioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Specializzazione', function(Specializzazione) {
                            return Specializzazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('specializzazione', null, { reload: 'specializzazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
